import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { v4 as uuid } from 'uuid'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { LabContactsActions } from '../StoreAdapter'
import { LabContactSchema } from '../../../Schema/LabContactSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { LabContactsAPI } from '../../../Services/API/LabContactsAPI'

export const useAddLabContact = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState<
    Record<string, string> | Record<string, string>[]
  >(null)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const addLabContact = useCallback(
    async (schema: LabContactSchema): Promise<LabContactSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(LabContactsAPI)
        .createEntity(schema)
        .then((schema) => {
          dispatch(LabContactsActions.addOne(schema))
          if (mounted.current) {
            setProcessing(false)
            setErrors(null)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setErrorMessage(err?.response?.data?.errorMessage)
            setErrors(err?.response?.data?.errors)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    errors,
    errorMessage,
    addLabContact,
  }
}
